import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
// import Loader from '../../pages/Loader/Loader';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  outline: 'none',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const theme = createTheme({
  palette: {
    neutral: {
      main: '#039255',
      contrastText: '#fff',
    },
    neutralsize: {
      width: '10px',
    },
  },
});

const VideoListModaldelete = ({ item, render, setRender }) => {
  const [open, setOpen] = React.useState(false);
  // const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setError('');
    setOpen(false);
  };

  const deleteHandler = async () => {
    try {
      // setLoading(true);
      const response = await fetch(
        `api/v1/a34jl49u-q4r67p89/courses/${item.course._id}/chapter/${item.chapter._id}/video/${item._id}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            withCredentials: true,
          },
        }
      );

      if (response.status === 200 || response.statusText === 'OK') {
        toast.success('success');
        setRender(!render);
        handleClose();
        return;
      }
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Button sx={{ minWidth: '10px' }} onClick={handleOpen}>
          <DeleteIcon sx={{ color: '#686868' }} />
        </Button>
      </ThemeProvider>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <Box sx={{ textAlign: 'center' }}>
            <HighlightOffIcon
              sx={{ fontSize: 50, color: 'red', marginBottom: 1 }}
            />
          </Box>
          <Typography
            sx={{ textAlign: 'center' }}
            id='modal-modal-title'
            variant='h6'
            component='h2'
          >
            Are you sure?
          </Typography>
          <Typography
            id='modal-modal-description'
            sx={{ mt: 2, textAlign: 'center' }}
          >
            Do you really want to delete these video? This process cannot be
            undone.
          </Typography>
          {/* {loading && <Loader />} */}
          {error && (
            <Box
              sx={{
                textAlign: 'center',
                color: 'rgb(255,0,0)',
                padding: '1rem',
                fontSize: '2rem',
                margin: '2rem 0',
              }}
            >
              {error}
            </Box>
          )}
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              onClick={handleClose}
              sx={{
                marginTop: 3,
                boxShadow: 'none !important',
                marginRight: 2,
              }}
              variant='contained'
            >
              Cancel
            </Button>
            <Button
              onClick={deleteHandler}
              sx={{ marginTop: 3, boxShadow: 'none !important' }}
              variant='contained'
              color='error'
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default VideoListModaldelete;
